import React, { useEffect, useState } from "react";

import Card from '../../../../components/Card';
import CardItem from '../../../../components/CardItem';
import PartnerPopUp from "./PartnerPopUp";

import partnerServices from "../../../../services/admFin/partnerServices";

import ActivityIndicator from '../../../../components/ActivityIndicator'
import { FaFilter, FaPen, FaPlus, FaPrint, FaTrash } from "react-icons/fa";
import { IoIosArrowDown } from 'react-icons/io'
import { PartnerInfoPopUp } from "./PartnerInfoPopUp";
import reportServices from "../../../../services/reportServices";
import PopupReports from "../../../../components/PopupReports";
import FilterPartnersPopUp from "./FilterPartnersPopUp";


export default function PartnersCard(props) {


    const [partnersToShow, setPartnersToShow] = useState([]);
    const [visibility, setVisibility] = useState(false);
    const [visibilityInfo, setVisibilityInfo] = useState(false);
    const [visibilityEdit, setVisibilityEdit] = useState(false);
    const [visibilityReport, setVisibilityReport] = useState(false);
    const [visibilityFilter, setVisibilityFilter] = useState(false);
    const [partnerInfo, setPartnerInfo] = useState({});
    const [showElements, setShowElements] = useState(false);


    useEffect(() => {
        if(props.partners && props.partners.length > 0)
            setPartnersToShow(props.partners);
    }, [props.partners]);

    


    async function createPartner(partner) {
        if (!partner.tipo || !partner.nome || !partner.documento || !partner.cep || !partner.pais || !partner.estado || !partner.cidade || !partner.bairro || !partner.logradouro || !partner.numero /* || !partner.iso2 || !partner.dialCode || !partner.telefone */) {
            alert("Os campos devem estar preenchidos");
            return;
        }
        try {
            const response = await partnerServices.postPartner(props.parceria, partnerServices.partnerType.find(subArr => subArr[1] === partner.tipo)[0], partner.nome, partner.documento, partner.cep, partner.pais, partner.estado, partner.cidade, partner.bairro, partner.logradouro, partner.numero, partner.inscricaoEstadual, partner.iso2, partner.dialCode, partner.telefone);
            props.setPartners(oldArray => {
                const temp = [...oldArray];
                temp.push(response.data);
                return temp;
            })
            setVisibility(false);
        } catch (err) {
            alert("Não foi possível criar o parceiro")
        }
    }

    async function editPartner(partner) {
        if ((partnerInfo.id !== 0 && !partnerInfo.id) || !partner.tipo || !partner.nome || !partner.documento || !partner.cep || !partner.pais || !partner.estado || !partner.cidade || !partner.bairro || !partner.logradouro || !partner.numero  /*|| !partner.iso2 || !partner.dialCode || !partner.telefone */) {
            alert("Os campos devem estar preenchidos");
            return;
        }
        try {
            const response = await partnerServices.patchPartner(partnerInfo.id, partnerServices.partnerType.find(subArr => subArr[1] === partner.tipo)[0], partner.nome, partner.documento, partner.cep, partner.pais, partner.estado, partner.cidade, partner.bairro, partner.logradouro, partner.numero, partner.inscricaoEstadual, partner.iso2, partner.dialCode, partner.telefone);
            props.setPartners(oldArray => {
                return oldArray.map(obj => {
                    if (obj.id === partnerInfo.id)
                        return response.data;
                    else
                        return obj;
                })
            })
            setVisibilityEdit(false);
        } catch (err) {
            alert("Não foi possível editar o parceiro")
        }
    }

    function generateReport(fields = null, fileName) {
        console.log(fields);
        try {
            reportServices.generateReportPartners(props.partners, `RELATÓRIO DE ${partnerServices.partnerServiceType[props.parceria][1].toUpperCase()}S`, fields, fileName);
            return true;
        } catch (err) {
            alert(err.message);
            return false;
        }
    }


    return (
        <Card
            tittle={props.tittle}
            options={
                <>

                    <button onClick={() => setVisibilityFilter(!visibilityFilter)} className="records-filter-button"><FaFilter /></button>
                    <FilterPartnersPopUp
                        visibility={visibilityFilter}
                        setVisibility={setVisibilityFilter}
                        partners={props.partners}
                        setPartnersToShow = {setPartnersToShow}
                    />

                    <button onClick={() => setVisibility(!visibility)} className="records-new-item-button"><FaPlus /></button>
                    <PartnerPopUp
                        tittle={`Novo ${partnerServices.partnerServiceType[props.parceria][1]}`}
                        buttonTittle="Criar"
                        visibility={visibility}
                        setVisibility={setVisibility}
                        parceria={props.parceria}
                        onClick={createPartner}
                        icon={props.icon}
                    />

                    <button title="Relatório" onClick={() => setVisibilityReport(true)} className="records-new-item-button"><FaPrint /></button>
                    <PopupReports
                        visibility={visibilityReport}
                        setVisibility={setVisibilityReport}
                        tittle={`Relatório de ${partnerServices.partnerServiceType[props.parceria][1]}`}
                        fields={reportServices.partnerFields}
                        generateReport={generateReport}
                    />

                    <button
                        onClick={() => setShowElements(!showElements)}
                        className={"records-hide-elements-button" + (showElements ? " showing" : "")}
                    >
                        <IoIosArrowDown />
                    </button>
                </>
            }
        >
            {
                !showElements ?
                    null
                    :
                    <div className="records-elements">
                        {
                            partnersToShow && partnersToShow.length ?
                                <>
                                    <PartnerPopUp
                                        tittle={`Editar ${partnerServices.partnerServiceType[props.parceria][1]}`}
                                        buttonTittle="Editar"
                                        visibility={visibilityEdit}
                                        setVisibility={setVisibilityEdit}
                                        parceria={props.parceria}
                                        onClick={editPartner}
                                        partner={partnerInfo}
                                        icon={props.icon}
                                    />

                                    <PartnerInfoPopUp
                                        partner={partnerInfo}
                                        visibility={visibilityInfo}
                                        setVisibility={setVisibilityInfo}
                                        icon={props.icon}
                                        parceria={props.parceria}
                                    />
                                    {
                                        partnersToShow.map((partner) =>
                                            <div className="records-element-container" key={partner.id}>
                                                <div onClick={() => {
                                                    setPartnerInfo(partner);
                                                    setVisibilityInfo(true);
                                                }}>
                                                    <CardItem
                                                        removeLeftSpace
                                                        bodyOptions={<span className="tag">COD {partner.id}</span>}
                                                    >
                                                        <h4>
                                                            {partner.nome}
                                                        </h4>
                                                    </CardItem>
                                                </div>

                                                <button onClick={() => {
                                                    console.log(partner);
                                                    setPartnerInfo(partner);
                                                    setVisibilityEdit(true);
                                                }}>
                                                    <FaPen />
                                                </button>

                                                <button className="red" onClick={() => props.deleteElement(partner.id, partnerServices.deletePartner, props.setPartners)}>
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        )
                                    }
                                </>
                                :
                                <ActivityIndicator />
                        }
                    </div>
            }
        </Card>


    )
}